import {
  CanDownloadContext,
  CanGenerateByOneflowContext,
  CanPreviewContext,
  CanSendToOneflowContext,
  GetOneflowTemplateIdContext,
  IConsultantContractStrategy
} from "../consultant-contract-strategy";

export class IntermittentUskContractStrategy implements IConsultantContractStrategy {
  public readonly name = "IntermittentUskContractStrategy";

  canPublishToOneflowDirectly(ctx: CanSendToOneflowContext): boolean {
    return true;
  }

  canPublishToOneflowViaTicket(ctx: CanSendToOneflowContext): boolean {
    return true;
  }

  getOneflowGeneratorType(ctx: CanGenerateByOneflowContext) {
    return null;
  }

  getOneflowTemplateId(ctx: GetOneflowTemplateIdContext) {
    if (ctx.env === "dev" || ctx.env === "staging") {
      return {
        workspaceId: "419741",
        templateId: "3929203"
      };
    }

    if (ctx.env === "production") {
      return {
        workspaceId: "406174",
        templateId: "3053323"
      };
    }

    throw new Error("unknown env");
  }

  canDuplicate(): boolean {
    return true;
  }

  canEdit(): boolean {
    return true;
  }

  canPreview(ctx: CanPreviewContext): boolean {
    return true;
  }

  canDownload(ctx: CanDownloadContext): boolean {
    return !!ctx.fileId;
  }

  defaultSalaryChoice(): null {
    return null;
  }
}
